import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CircularProgressIcon = styled(CircularProgress)`
  margin: auto;
`;
